export default __webpack_public_path__ + "static/media/receipt.1733f03d.svg";